import styled from '@emotion/styled';
import type { OneDriveFile } from '../../types';
import CannotPickItemWarning from '../utils/CannotPickItemWarning';

const StyledFileLink = styled('a')({
  marginTop: 8,
  marginRight: 24,
  color: 'inherit',
  maxWidth: 450,
  textOverflow: 'ellipsis',
  textWrap: 'nowrap',
  overflow: 'hidden',
  display: 'inline-block',
  ':hover, :focus': {
    textDecoration: 'underline',
  },
});

type FileNameCellProps = {
  file: OneDriveFile;
};

const FileNameCell = ({ file }: FileNameCellProps) => (
  <th scope="row">
    {file.webUrl ? (
      <StyledFileLink
        href={file.webUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {file.name}
      </StyledFileLink>
    ) : (
      file.name
    )}
    {!file.webUrl && <CannotPickItemWarning variant="file" />}
  </th>
);

export default FileNameCell;
